import { createFileRoute } from "@tanstack/react-router";

import { DietPlanBuilder } from "@/features/diet-plans/modules/diet-plan-builder/diet-plan-builder";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(private)/trainees/$clientId/diet-plans/$planId")({
  loader: () => ({ crumb: m.diet_plan_crumb() }),
  component: RouteComponent,
});

function RouteComponent() {
  const { clientId, planId } = Route.useParams();
  return <DietPlanBuilder clientId={clientId} planId={planId} />;
}
